// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__nw2o1","dragIcon":"Choice_dragIcon__2ADXt","left":"Choice_left__205_4","input":"Choice_input__33iKX"};